import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  loading: Boolean;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Boolean> {
    if (!!this.authenticationService.currentUser) {
      return Promise.resolve(true);
    } else {
      this.loading = true;

      return this.authenticationService.isValidSession()
        .then((isValid: Boolean) => {
          if (isValid) {
            this.loading = false;
            return true;
          }
          throw 'invalid session';
        })
        .catch(() => {
          this.loading = false;
          this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
          return false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts